import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';

import { CopyrightFooter } from '@components/copyright-footer/copyright-footer';
import { createForm } from '@components/form/create-form';
import { DynamicFields, FormV2 } from '@components/form/v2';
import { noop } from '@utils/browser';
import { pxToRem } from '@utils/converters';

import { ViewportType } from './state';
import { ViewportPreview } from './viewport-preview';

const Form = createForm();

export const PreviewFields = ({
  viewport,
  fields,
}: {
  viewport: ViewportType;
  fields: FormV2['fields'];
}) => {
  return (
    <ViewportPreview viewport={viewport}>
      <PreviewContainer>
        <Form onSubmit={noop}>
          <AnimatePresence>
            <motion.div layout="position" data-mobile={viewport === 'mobile'}>
              <DynamicFields fields={fields} preview />
            </motion.div>
          </AnimatePresence>
          <CopyrightFooter marginTop={16} />
        </Form>
      </PreviewContainer>
    </ViewportPreview>
  );
};

const PreviewContainer = styled.div({
  width: '100%',
  maxWidth: pxToRem(535),

  '[data-viewport="desktop"] &': {
    maxWidth: pxToRem(465),
  },
});
